export default __webpack_public_path__ + "assets/dc8e1755a6be7583b192d208cad78b8d.svg";